export default __webpack_public_path__ + "static/media/poccLogo.d338c7ec.png";